import PP1 from '../../images/emisImages/pp1.png';
import PP2 from '../../images/emisImages/pp2.png';
import PP3 from '../../images/emisImages/pp3.png';
import PP4 from '../../images/emisImages/pp4.png';
import PP5 from '../../images/emisImages/pp5.png';
import PP6 from '../../images/emisImages/pp6.png';
import PP7 from '../../images/emisImages/pp7.png';
import PP8 from '../../images/emisImages/pp8.png';
import PP9 from '../../images/emisImages/pp9.png';



export default {
    about : "an information technology based company since 2004, in Education and Training, is offering wide range of that include creating educational and training content of global relevance,designing and executing large learning initiatives and setting up the requisite infrastructure.",
    serviceContent :  [
        {
          title: "Personalized portals and dashboards",
          icon: PP1,
          content:
            "The dashboard comes with a flexible functionality, which allows administrator to create number of portals personalized for students, faculty and parents.",
        },
        {
          title: "360 degree student profile",
          icon: PP2,
          content:
            "Right from academic reports, attendance information, grading and examination results – Everything on the screen with details",
        },
        {
          title: "Alerts and notifications",
          icon: PP3,
          content:
            "Enabling timely alerts and sending push notifications to students, parents, and teachers.",
        },
        {
          title: "Integrated academic calendar",
          icon: PP4,
          content:
            "EMIS system is the perfect medium to integrate your academic calendar, through simple excel import option and work your plan",
        },
        {
          title: "Inbuilt attendance – biometric/RFID integration",
          icon: PP5,
          content:
            "No more hassles of paper-based attendance routine. Go paperless and free your faculty from the monotonous manual work with EMIS.",
        },
        {
          title: "Multi-language support",
          icon: PP6,
          content:
            "Depending upon the user’s language preference and location, the multilingual system - EMIS is adaptable.",
        },
        {
          title: "Question bank",
          icon: PP7,
          content:
            "Our educational experts have curated a large sorted NTA based question bank with solutions.",
        },
        {
          title: "Informative videos",
          icon: PP8,
          content:
            "Redefine your students learning experience by letting them access video lectures, and informative videos. Align into the futuristic learning and stay ahead of the competition.",
        },
        {
            title: "Lecturer notes",
            icon: PP9,
            content:
              "Taking the lecturer notes and referring them offline consumes enormous amount of time and efforts. Let you students access their lecturer’s notes, right after the completion of class.",
          }
      ],

     
  }
 